import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
// import './pagination.scss';
const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;




  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage == 0 || typeof paginationRange == "undefined" || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    handlePaginationClick(currentPage + 1)
  };

  const onPrevious = () => {
    handlePaginationClick(currentPage - 1)

  };

  const handlePaginationClick = (pageNumber) => {
    onPageChange(pageNumber);

    let container = document.querySelector('.filter-block'),
          template = document.querySelector('.template'),
          template_height = template.offsetHeight,
          pos = container.offsetTop;
    window.scrollTo(0, template_height + pos - 100)


  }

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className="results-pagination">
    <ul
      className={classnames('pagination', { [className]: className })}
    >
      <li
        className={classnames('pagination-item back', {
          disabled: currentPage == 1
        })}
        onClick={onPrevious}
      >

        <div className="sr-only">Back</div>

        <a>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
        <path d="M6.94922 1.5498L1.99947 6.49955L6.94922 11.4493" stroke="#2D2D2C" stroke-width="2"/>
        </svg>
        </a>
      </li>
      {paginationRange.map(pageNumber => {
        if (pageNumber == DOTS) {
          return <li className="pagination-item dots"><span>&#8230;</span></li>;
        }

        return (
          <li
            className={classnames('pagination-item', {
              selected: pageNumber == currentPage
            })}
            onClick={() => handlePaginationClick(pageNumber)}
          >
            <a>{pageNumber}</a>
          </li>
        );
      })}
      <li
        className={classnames('pagination-item next', {
          disabled: currentPage === lastPage
        })}
        onClick={onNext}
      >

      <a>
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
      <path d="M0.849609 1.5498L5.79936 6.49955L0.849609 11.4493" stroke="#2D2D2C" stroke-width="2"/>
      </svg>
      </a>

        <div className="arrow right sr-only">Next</div>
      </li>
    </ul>
    </div>
  );
};

export default Pagination;
